import groq from 'groq'

import { feeProductVariantFragment } from './fee'
import { imageFragment } from './image'
import { linkPageFragment } from './link'
import { videoFragment } from './video'

const markDefFragment = groq`
  ...,
  _type == "link" => {
    page->{
      ${linkPageFragment}
    },
  },
`

export const simplePortableTextFragment = groq`
  ...,
  "markDefs": coalesce(markDefs[] {
    ${markDefFragment}
  }, []),
`

const addToCartButtonFragment = groq`
  productVariant->{
    variantID,
    inStock,
    price,
    comparePrice,
    "fees": *[
      _type == "product" &&
      productID == ^.productID &&
      !wasDeleted &&
      !isDraft
    ][0].fees[]->{
      ${feeProductVariantFragment}
    },
  },
`

const videoButtonFragment = groq`
  video {
    ${videoFragment}
  },
`

export const complexPortableTextFragment = groq`
  ...,
  "markDefs": coalesce(markDefs[] {
    ${markDefFragment}
  }, []),
  _type == "addToCartButton" => {
    ${addToCartButtonFragment}
  },
  _type == "figure" => {
    ${imageFragment}
  },
  _type == "videoButton" => {
    ${videoButtonFragment}
  },
`
